import { useMutation } from "@apollo/client";
import { RequestOrderDesignDocument } from "../../gql/generated/graphql";

export const useRequestOrderDesign = () => {
  const [requestOrderDesign, { loading }] = useMutation(
    RequestOrderDesignDocument
  );

  return {
    requestOrderDesign: (orderId: string) =>
      requestOrderDesign({
        variables: {
          orderId,
        },
      }),
    isRequestingOrderDesign: loading,
  };
};
